import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  product_id: null,
  product_name: null,
  product_status: null,
  product_edit: false,
  productIsPane: false,
  product_image_path: null,
  addproductIsPane: false,
  product_filter: true,
  product_Buid: null,
  product_Divid: null,
  bu_edit: false,
};
export const productReducerInner = createSlice({
  name: "product",
  initialState: initialState,
  reducers: {
    product_id(state, action) {
      state.product_id = action.payload;
    },
    product_name(state, action) {
      state.product_name = action.payload;
    },
    product_description(state, action) {
      state.product_description = action.payload;
    },
    product_status(state, action) {
      state.product_status = action.payload;
    },
    product_image_path(state, action) {
      state.product_image_path = action.payload;
    },
    product_edit(state, action) {
      state.product_edit = action.payload;
    },
    product_IsPane(state, action) {
      state.productIsPane = action.payload;
    },
    addproduct_IsPane(state, action) {
      state.addproductIsPane = action.payload;
    },
    product_filter(state, action) {
      state.product_filter = action.payload;
    },

    product_Divid(state, action) {
      state.product_Divid = action.payload;
    },
    bu_edit(state, action) {
      state.bu_edit = action.payload;
    },
  },
});
